import { Avatar, WindmillContext } from "@windmill/react-ui";
import Cookies from "js-cookie";
import socket from "services/SocketService";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  IoLogOutOutline,
  IoMoonSharp,
  IoSettingsOutline,
  IoSunny,
} from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { AdminContext } from "context/AdminContext";
import { emptySetting } from "redux/Actions/SettingActions";
import { emptySideBarMenu } from "redux/Actions/SideBarActions";
import drakLogo from "../../assets/img/logo/logo-dark.svg";
import lightLogo from "../../assets/img/logo/logo-light.svg";
import { useChatStatus } from "context/ChatStatusContext";
import { teardownPushNotifications } from "utils/browserNotify";
import ChatServices from "services/ChatServices";

const Header = () => {
  const reduxDisPatch = useDispatch();

  const {
    isOnline,
    statusBusy,
    goOnline,
    goOffline,
  } = useChatStatus();

  const { state, dispatch } = useContext(AdminContext);
  const { adminInfo } = state;
  const { mode, toggleMode } = useContext(WindmillContext);

  const [profileOpen, setProfileOpen] = useState(false);

  const pRef = useRef();
  const { t } = useTranslation();

  // const handleLogOut = async () => {

  //   await teardownPushNotifications(ChatServices.deletePushSubscription);

  //   dispatch({ type: "USER_LOGOUT" });

  //   Cookies.remove("adminInfo");
  //   localStorage.removeItem("adminInfo");
  //   sessionStorage.removeItem("isOnline");

  //   socket.disconnect();

  //   reduxDisPatch(emptySideBarMenu());
  //   reduxDisPatch(emptySetting());
  // };


  const handleLogOut = async () => {
    try {
      if (isOnline) {
        await goOffline();
      }
    } catch (error) {
      console.error("Failed to update chat status to offline:", error);
    }

    try {
      await teardownPushNotifications(
        ChatServices.deletePushSubscription
      );
    } catch (error) {
      console.error("Failed to remove push subscription:", error);
    }

    dispatch({ type: "USER_LOGOUT" });

    Cookies.remove("adminInfo");
    localStorage.removeItem("adminInfo");
    sessionStorage.removeItem("isOnline");

    socket.disconnect();

    reduxDisPatch(emptySideBarMenu());
    reduxDisPatch(emptySetting());
  };


  const profile = adminInfo?.profile;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!pRef?.current?.contains(e.target)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleProfileOpen = () => {
    setProfileOpen((prev) => !prev);
  };

  return (
    <header className="z-30 py-4 bg-white shadow-sm dark:bg-gray-800">
      <div className="flex items-center justify-between h-full px-3 sm:px-6 mx-auto text-green-500 dark:text-green-500">
        <NavLink to="/dashboard" className="logo-details">
          <img
            src={mode === "dark" ? drakLogo : lightLogo}
            className="mainIcon small"
            alt="B2bLogo"
          />
        </NavLink>

        <ul className="flex justify-end items-center flex-shrink-0 space-x-6">
          {/* <li className="flex">
            <button
              className="rounded-md focus:outline-none"
              onClick={toggleMode}
              aria-label="Toggle color mode"
            >
              {mode === "dark" ? (
                <IoSunny
                  className="w-5 h-5"
                  aria-hidden="true"
                />
              ) : (
                <IoMoonSharp
                  className="w-5 h-5"
                  aria-hidden="true"
                />
              )}
            </button>
          </li> */}
          {profile === "User" && (
            <div className="w-full flex justify-end">
              <button
                type="button"
                onClick={isOnline ? goOffline : goOnline}
                disabled={statusBusy}
                aria-label={`Switch to ${isOnline ? "offline" : "online"}`}
                className={`flex items-center gap-2 rounded-full transition-all duration-300 ${statusBusy ? "cursor-not-allowed opacity-60" : "cursor-pointer"
                  }`}
              >
                <div className="flex items-center gap-2">
                  <span
                    className={`h-2.5 w-2.5 rounded-full transition-all duration-300 ${isOnline
                      ? "bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.7)]"
                      : "bg-red-600"
                      }`}
                  />

                  <span
                    className={`text-xs sm:text-sm font-semibold transition-colors duration-300 ${isOnline ? "text-green-600" : "text-red-600"
                      }`}
                  >
                    {statusBusy
                      ? "Connecting..."
                      : isOnline
                        ? "Online"
                        : "Offline"}
                  </span>
                </div>

                <span
                  className={`relative h-7 w-12 shrink-0 rounded-full p-1 transition-colors duration-300 ${isOnline ? "bg-green-500" : "bg-red-600"
                    }`}
                >
                  <span
                    className={`block h-5 w-5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${isOnline
                      ? "translate-x-5"
                      : "translate-x-0"
                      }`}

                  />
                </span>
              </button>
            </div>
          )}

          <li
            className="relative inline-block text-left"
            ref={pRef}
          >
            <button
              type="button"
              onClick={handleProfileOpen}
              className="relative flex items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
              style={{
                width: "42px",
                height: "42px",
                padding: 0,
                background: "transparent",
              }}
            >
              {adminInfo?.image ? (
                <Avatar
                  className="align-middle"
                  src={adminInfo.image}
                  aria-hidden="true"
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #ffffff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
                  }}
                />
              ) : (
                <div
                  className="flex items-center justify-center rounded-full bg-green-500"
                  style={{
                    width: "42px",
                    height: "42px",
                    color: "#ffffff",
                    fontSize: "17px",
                    fontWeight: "600",
                    border: "2px solid #ffffff",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
                  }}
                >
                  {adminInfo?.email?.[0]?.toUpperCase() || "A"}
                </div>
              )}

              {/* <span
                className={`absolute bottom-0 right-0 rounded-full border-2 border-white ${isOnline ? "bg-green-400" : "bg-gray-400"
                  }`}
                style={{
                  width: "13px",
                  height: "13px",
                }}
              /> */}
            </button>

            {profileOpen && (
              <ul
                className="origin-top-right absolute right-0 mt-3 overflow-hidden rounded-xl bg-white dark:bg-gray-800"
                style={{
                  width: "230px",
                  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
                  border: "1px solid rgba(0, 0, 0, 0.06)",
                  zIndex: 9999,
                }}
              >
                {adminInfo?.profile === "User" && (
                  <li className="px-4 py-4 border-b border-gray-100 dark:border-gray-700">
                    <div className="flex items-center justify-between mb-3">
                      <div>
                        <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">
                          Chat Status
                        </p>

                        <div className="flex items-center mt-1">
                          <span
                            className={`w-2.5 h-2.5 rounded-full mr-2 ${isOnline ? "bg-green-500" : "bg-gray-400"
                              }`}
                          />

                          <span
                            className={`text-xs font-medium ${isOnline
                              ? "text-green-600 dark:text-green-400"
                              : "text-gray-500 dark:text-gray-400"
                              }`}
                          >
                            {isOnline ? "Online" : "Offline"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {!isOnline ? (
                      <button
                        type="button"
                        onClick={goOnline}
                        disabled={isOnline || statusBusy}
                        className={`w-full px-4 py-2 rounded-lg text-sm font-semibold text-white transition-colors duration-200 ${statusBusy
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-green-500 hover:bg-green-600"
                          }`}
                      >
                        {statusBusy ? "Connecting..." : "Go To Online"}
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={goOffline}
                        disabled={!isOnline || statusBusy}
                        className={`w-full px-4 py-2 rounded-lg text-sm font-semibold text-white transition-colors duration-200 ${statusBusy
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-red-500 hover:bg-red-600"
                          }`}
                      >
                        {statusBusy ? "Updating..." : "Go To Offline"}
                      </button>
                    )}
                  </li>
                )}

                <li>
                  <Link
                    to="/edit-profile"
                    onClick={() => setProfileOpen(false)}
                    className="flex items-center px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-300 transition-colors duration-150 hover:bg-gray-50 hover:text-green-600 dark:hover:bg-gray-700 dark:hover:text-green-400"
                  >
                    <IoSettingsOutline
                      className="w-5 h-5 mr-3"
                      aria-hidden="true"
                    />

                    <span>{t("EditProfile")}</span>
                  </Link>
                </li>

                <li
                  onClick={handleLogOut}
                  className="flex items-center px-4 py-3 text-sm font-medium text-gray-600 dark:text-gray-300 cursor-pointer transition-colors duration-150 hover:bg-gray-50 hover:text-red-500 dark:hover:bg-gray-700 dark:hover:text-red-400"
                >
                  <IoLogOutOutline
                    className="w-5 h-5 mr-3"
                    aria-hidden="true"
                  />

                  <span>{t("LogOut")}</span>
                </li>
              </ul>
            )}
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;

